module.exports = __webpack_public_path__ + "static/w_neun_protrait-ecf0e92ddfe090309aa8df0067ac5c8a.jpg";